import React from 'react'
import styles from './styles.module.scss'

const QrCode = ({ className }) => {
  return (
    <div className={className}>
      <img
        className={styles.qrCode}
        src="https://tools-qr-production.s3.amazonaws.com/output/apple-toolbox/4598995ac7bd7edda6752c84e522b529/25003ac6bb84689b33b1539e03f464af.png"
      ></img>
    </div>
  )
}

export default QrCode
